export const sendRequestModule = {
    
    sendRequest(cart, contactData) {
        this.emit("fetch", cart, contactData)
        this.emit("startRequest", cart, contactData);
    },

    loadData() {
        this.emit("load")
    },

    completeLoading(cart, contactData) {
        this.emit("loadComplete")
    },

    createContent(data) {
        this.emit("create", data)
    },

    redirectUser() {
        this.emit("redirect")
    },


    emitError(message = "") {
        console.error("Not possible to send anything to the backend.")
        console.error(message);
        this.emit("error", message);
    },


    events: {},
    /**
     * Löst ein Ereignis aus. Dieser Funktion dürfen beliebig viele
     * params übergeben werden, diese werden 1:1 an die Event-Listener
     * durchgereicht.
     *
     * @param {string} eventName
     * @param {*=} params
     */
    emit(eventName, param = null, param2 = null) {
        if (eventName in this.events) {
            for (const f of this.events[eventName]) {
                f(param, param2)
            }
        }
    },
    /**
     * Registriert einen Event-Listener für das Event eventName.
     *
     * @param {string} eventName
     * @param {Function} cb
     */
    on(eventName, cb) {
        // Hier ist die Klammersetzung ganz wichtig!
        if (!(eventName in this.events)) {
            this.events[eventName] = []
        }
        this.events[eventName].push(cb)
    }
}


sendRequestModule.on("fetch", (cart, contactData) => {
    sendRequestDataFetchRequest(cart, contactData)
})


export function sendRequestDataFetchRequest(cart, contactData) {
    sendRequestModule.loadData()
    jQuery.ajax({
        url: cloudmanufaktur.ajaxurl,
        type: 'post',
        data: {
            action: "processRequest",
            cart: cart,
            contactData: contactData
        },
        error: (data) => {
            console.error(data)
            sendRequestModule.emitError("Beim versenden ist etwas schief gegangen. Bitte versuchen Sie es später noch einmal.");
        },
        success: function (data) {
            sendRequestModule.createContent(data)
            sendRequestModule.completeLoading()
        }
    })
}